import { PayloadAction } from '@reduxjs/toolkit';
import { ActiveFilters, SearchSortBy, SearchState, SEARCH_DEFAULT_SORT_BY } from '../types';

interface SetSearchParamsPayload {
  filters: ActiveFilters;
  pageNr: number;
  sortBy: string;
  query: string;
}

const setSearchParamsReducer = (state: SearchState, action: PayloadAction<SetSearchParamsPayload>) => {
  state.pageNr = action.payload.pageNr || 1;
  // state.offset - we do not set offset here, need to confirm later
  state.searchQuery = action.payload.query;
  state.settings = {
    filters: action.payload.filters,
    sortBy: (action.payload.sortBy || SEARCH_DEFAULT_SORT_BY) as SearchSortBy,
    defaultFilters: state.settings.defaultFilters,
  };
};

export default setSearchParamsReducer;
